import script from "./SponsorsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SponsorsView.vue?vue&type=script&setup=true&lang=js"

import "./SponsorsView.vue?vue&type=style&index=0&id=c15086b8&lang=scss"

const __exports__ = script;

export default __exports__